"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelsListDef = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
const component_1 = require("../component");
exports.PanelsListDef = Object.assign(Object.assign({}, __1.daoObjSchemaDef), { businessUnitId: joi_1.default.string().required(), session: joi_1.default.object({
        id: joi_1.default.number().required(),
        type: joi_1.default.string().required(),
        year: joi_1.default.string().required(),
    }), componentType: component_1.componentTypeSchema, examiner: joi_1.default.object({
        name: joi_1.default.string().required(),
        creditorNumber: joi_1.default.number().required(),
    }), data: joi_1.default.array().items(joi_1.default.object({
        panel: joi_1.default.object({
            id: joi_1.default.number().required(),
            name: joi_1.default.string().required(),
        }),
        examinerDetails: joi_1.default.object({
            roleId: joi_1.default.string().required(),
            roleName: joi_1.default.string().required(),
            teamPosition: joi_1.default.string().required(),
            assessment: joi_1.default.object({
                code: joi_1.default.string().required(),
                version: joi_1.default.number().required(),
                componentId: joi_1.default.string().required(),
            }),
        }),
    })) });
